import React from 'react'
import './RotateLogo.css';

function RotateLogo() {
  return (
    <div>
          <div className="rl">
        <img src="ro-logo2.png" className="App-logo" alt="logo" />
    </div>
    </div>
  )
}

export default RotateLogo
